import { render } from "./Installer.vue?vue&type=template&id=18e2c06e"
import script from "./Installer.vue?vue&type=script&lang=js"
export * from "./Installer.vue?vue&type=script&lang=js"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__